import React, { useState, useMemo } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { selectAdminSchedule } from "../store/content/selectors";
import AdminScheduleItem from "./AdminScheduleItem";
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import {
    clearAdminError,
    setAdminError,
    uploadSchedule,
    clearAdminMessage,
    imagesUploadError
} from "../store/content/actions";

const AdminSchedule = ({ token, lang }) => {
    const dispatch = useDispatch();
    const [link, setLink] = useState('');
    const [descRu, setDescRu] = useState('');
    const [descEng, setDescEng] = useState('');
    const [nameRu, setNameRu] = useState('');
    const [nameEng, setNameEng] = useState('');
    const [placeRu, setPlaceRu] = useState('');
    const [placeEng, setPlaceEng] = useState('');
    const [time, setTime] = useState('');
    const [yandex, setYandex] = useState('');
    const [length, setLength] = useState(0);
    const [sortUp, setSortUp] = useState(null); // null – без сортировки, true – по возрастанию, false – по убыванию

    const schedules = useSelector(selectAdminSchedule);

    // Вспомогательная функция для парсинга даты из строки "dd.mm.yyyy hh:mm"
    const parseDate = (timeString) => {
        if (!timeString) return null;
        const [datePart, timePart] = timeString.split(' ');
        if (!datePart) return null;
        const [day, month, year] = datePart.split('.');
        if (!day || !month || !year) return null;
        const [hour, minute] = timePart ? timePart.split(':') : [0, 0];
        return new Date(`${year}-${month}-${day}T${hour}:${minute}:00`);
    };

    // Мемоизированный отсортированный массив
    const sortedSchedules = useMemo(() => {
        if (!schedules) return [];

        // Если сортировка не нужна, возвращаем копию (чтобы не мутировать оригинал)
        if (sortUp === null) return [...schedules];

        // Копируем и сортируем
        const sorted = [...schedules];
        sorted.sort((a, b) => {
            const dateA = parseDate(a.time);
            const dateB = parseDate(b.time);

            // Элементы без даты отправляем в конец
            if (!dateA && !dateB) return 0;
            if (!dateA) return 1;
            if (!dateB) return -1;

            return sortUp ? dateA - dateB : dateB - dateA;
        });
        return sorted;
    }, [schedules, sortUp]);

    // Валидация файлов (без изменений)
    const fileValidation = () => {
        const allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif)$/i;
        const fileInput = document.getElementById('file_input');
        if (fileInput.files.length > 0) {
            for (let i = 0; i < fileInput.files.length; i++) {
                if (!allowedExtensions.exec(fileInput.files[i].name)) {
                    dispatch(clearAdminError());
                    setTimeout(() => {
                        dispatch(imagesUploadError('Допустимые расширения файлов: .jpeg .jpg .png .gif'));
                    }, 100);
                    fileInput.value = '';
                    setLength(0);
                    return false;
                }
            }
            setLength(fileInput.files.length);
        } else {
            setLength(0);
        }
    };

    // Отправка формы (без изменений)
    const handleSubmit = (e) => {
        e.preventDefault();

        if (!descRu || !nameRu || !placeRu || !time) {
            dispatch(clearAdminError());
            setTimeout(() => {
                dispatch(setAdminError('Заполни поля, Кирилл'));
            }, 100);
            return;
        }

        const fileInput = document.getElementById('file_input');
        const formData = new FormData();
        for (let i = 0; i < fileInput.files.length; i++) {
            formData.append("files[]", fileInput.files[i]);
        }

        dispatch(clearAdminMessage());
        setTimeout(() => {
            dispatch(uploadSchedule({
                link,
                nameRu,
                nameEng,
                placeRu,
                placeEng,
                time,
                descriptionRu: descRu,
                descriptionEng: descEng,
                yandex
            }, formData, token));
        }, 100);

        fileInput.value = '';
        setLength(0);
    };

    // Циклическое переключение направления сортировки: null → true → false → null
    const toggleSort = () => {
        setSortUp(prev => prev === null ? true : prev === true ? false : null);
    };

    return (
        <>
        <div className="admin-content-container schedule-content-container">
            <div className="pictures-container schedule-container">
                <div className="pictures-header">
                    <span style={{width: '100%'}}>ID</span>
                    <span style={{width: '100%'}}>Фото</span>
                    <span style={{width: '100%'}}>{lang ? 'Название(ENG)' : 'Название(RU)'}</span>
                    <span style={{width: '100%'}}>{lang ? 'Описание(ENG)' : 'Описание(RU)'}</span>
                    <span style={{width: '100%'}}>{lang ? 'Место(ENG)' : 'Место(RU)'}</span>
                    <span style={{width: '100%', cursor: 'pointer', color: 'rgb(235, 174, 52)'}} onClick={toggleSort}>
                        Время&nbsp;
                        {sortUp !== null && (
                            <span style={{verticalAlign: 'middle'}}>
                                {sortUp ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                            </span>
                        )}
                    </span>
                    <span style={{width: '100%'}}>Карты</span>
                    <span style={{width: '100%'}}>Билеты</span>
                    <span style={{width: '100%'}}>Действие</span>
                </div>
                {sortedSchedules.map(schedule => (
                    <AdminScheduleItem key={schedule.id} lang={lang} schedule={schedule} token={token} />
                ))}
            </div>
                <div className="admin-video-add schedule-add">
                    <form className="schedule-form" action="" onSubmit={e => handleSubmit(e)}>
                        <label className="custom-file-upload">
                            <input type="file" className="form-control" id="file_input"
                                   onChange={fileValidation}/>
                            {length > 0 ? 'Фото выбрано' : 'Выбрать фото'}
                        </label>
                        <input type="text" value={nameRu} placeholder="Название события (RU)"
                               onChange={e => setNameRu(e.target.value)}/>
                        <input type="text" value={nameEng} placeholder="Название события (ENG)"
                               onChange={e => setNameEng(e.target.value)}/>
                        <input type="text" value={placeRu} placeholder="Где (RU)"
                               onChange={e => setPlaceRu(e.target.value)}/>
                        <input type="text" value={placeEng} placeholder="Где (ENG)"
                               onChange={e => setPlaceEng(e.target.value)}/>
                        <input type="text" value={time} placeholder="Когда(dd.mm.yyyy hh:mm)"
                               onChange={e => setTime(e.target.value)}/>
                        <input type="text" value={yandex} placeholder="Яндекс карты"
                               onChange={e => setYandex(e.target.value)}/>
                        <input type="text" value={link} placeholder="Ссылка на билет"
                               onChange={e => setLink(e.target.value)}/>
                        <textarea value={descRu} placeholder="Описание события (RU)"
                                  onChange={e => setDescRu(e.target.value)}/>
                        <textarea value={descEng} placeholder="Описание события (ENG)"
                                  onChange={e => setDescEng(e.target.value)}/>
                        <button className="admin-button" type="submit">Отправить</button>
                    </form>
                </div>
            </div>
        </>
    );
};

export default AdminSchedule;